export const OPTIONAL_TEXT_MAX_LENGTH = 100;

export function sanitizeOptionalText(input) {
  if (input === null || input === undefined) return '';
  let str = String(input);
  let cleaned = '';
  for (const char of str) {
    const code = char.codePointAt(0);
    if (code === undefined) {
      continue;
    }
    if (code >= 0x20 && code !== 0x7f) {
      cleaned += char;
    }
  }
  str = cleaned;
  if (str.length > OPTIONAL_TEXT_MAX_LENGTH) {
    str = str.slice(0, OPTIONAL_TEXT_MAX_LENGTH);
  }
  return str.trim();
}
